export type ReceivedModel<T> = T & { readonly id: string }
